import { ActionResponse, ActionStatusHelper, RecordMap, useAuditEnricher } from "@/Shared";
import { useMandate, useTransaction } from "@/OneLiners";

import { LeaseModel } from "../LeaseModel";

export function useLeaseEnricher() {

    const { dataMap: mandateMap, stateResponse: mandateResponse } = useMandate();
    const { dataMap: transactionMap, stateResponse: transactionResponse } = useTransaction();

    /**
         * Centralized audit enrichment hook
         * - Provides O(1) user resolution via precomputed Map
         * - Exposes audit enrichment helpers and status/error
         */
    const {
        enricherResponse: auditEnricherResponse,
        userMap,
        getUserById,
        getEnrichedAudit,
    } = useAuditEnricher<LeaseModel>();

    const enricherResponse: ActionResponse = {
        status: ActionStatusHelper.combine(
            mandateResponse.status,
            auditEnricherResponse.status,
            transactionResponse.status
        ),
        error: mandateResponse.error ??
            transactionResponse.error ??
            auditEnricherResponse.error
    };

    const getEnrichedLeaseMap = (leaseMap: RecordMap<LeaseModel>): RecordMap<LeaseModel> => {

        return leaseMap.map<LeaseModel>(getStrictEnrichedLease);
    }

    const getStrictEnrichedLease = (lease: LeaseModel): LeaseModel => {
        return {
            ...getEnrichedAudit(lease),
            transaction: lease.transactionId
                ? transactionMap.get(lease.transactionId)
                : undefined
        }
    }

    const getEnrichedLease = (lease?: LeaseModel): LeaseModel | undefined => {

        if (!lease) return undefined;
        return getStrictEnrichedLease(lease);
    }


    return {
        userMap,
        transactionMap,
        mandateMap,
        enricherResponse,
        getEnrichedLease,
        getStrictEnrichedLease,
        getEnrichedLeaseMap,
    }
}